﻿import $ from "jquery";
import Program from "./Program";
import PositionController from "./PositionController";

const closeButtonSelector = "div[data-logo-hover-close-button]";

export default class Hover extends Program {
	constructor() {
		super(...arguments);

		this.$popup.appendTo("body");

		this.positionController =
			new PositionController(this.$icon, this.$popup, this.settings.hoverDirection);

		this.initIconEvents();
		this.initHoverEvents();
		this.initLoadingIndicator();
	}

	initIconEvents() {
		if (this.settings.openHoverOnClick) {
			this.initIconClick();
			return;
		}

		this.$icon.on("mouseenter", () => this.onIconMouseEnter());

		this.$icon.on("keypress", (e) => {
			if (e.keyCode === 13)
				this.onIconMouseEnter();
		});

		if (this.settings.closeOnMouseLeave) {
			this.$icon.on("mouseleave", () => this.onIconMouseLeave());
		}
	}

	onIconMouseEnter() {
		if (this.isPopupOpened && this.settings.closeOnMouseLeave) {
			clearTimeout(this.closingTimeoutId);
			return;
		}

		if (!this.settings.openHoverOnClick) {
			this.openingTimeoutId = setTimeout(() => this.open(),
				this.settings.hoverOpenDelay);
		}
	}

	onIconMouseLeave() {
		if (!this.isPopupOpened) {
			clearTimeout(this.openingTimeoutId);
			return;
		}

		this.closingTimeoutId = setTimeout(() => this.close(),
			this.settings.hoverCloseDelay);
	}

	initHoverEvents() {
		var self = this;
		$(this.$popup.parent()).on("keydown", function (e) {
			if (e.keyCode === 27) {
				self.onHoverMouseLeave();
			}
		});

		if (!this.settings.closeOnMouseLeave) {
			this.$popup.on("click",
				closeButtonSelector,
				() => this.close());

			this.$popup.on("keypress",
				closeButtonSelector, (e) => {
					if (e.keyCode === 13) {
						this.close();
					}
				});
			return;
		}

		this.$popup.on({
			mouseenter: () => this.onHoverMouseEnter(),
			mouseleave: () => this.onHoverMouseLeave()
		});
	}

	onHoverMouseEnter() {
		if (!this.isPopupOpened) {
			return;
		}

		clearTimeout(this.closingTimeoutId);
	}

	onHoverMouseLeave() {
		this.closingTimeoutId = setTimeout(
			() => this.close(),
			this.settings.hoverCloseDelay);
	}

	openPopup() {
		super.openPopup();
		this.resize();
		this.$popup.show();
	}

	closePopup() {
		this.$popup.hide();
	}

	resize() {
		this.positionController.init();
		if (this.hasIframe) {
			const $popup = this.$popup;
			const $iframe = $popup.find("iframe");

			// get initial width. If not set then set to data-width attribute
			const originalWidth = $iframe.data("width") || $iframe.data("width", $iframe.width()).data("width");

			const viewPortWidth = $(window).width() - $iframe.position().left - 5;

			if (originalWidth > viewPortWidth) {
				$iframe.css("width", viewPortWidth + "px");
			} else {
				$iframe.css("width", "");
			}
		}
	}

	initLoadingIndicator() {
		window.addEventListener("message", (event) => {
			this.messageHandler(event);
		}, false);
	}

	messageHandler(event) {
		let isMessageReceived = true;
		let data = {};

		try {
			data = $.parseJSON(event.data);
			if (!data.hoverLoad) {
				isMessageReceived = false;
			}
		} catch (e) {
			isMessageReceived = false;
		}

		if (!isMessageReceived)
			return;

		this.hideLoading(data.hoverLoad);
	}
}